import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import styles from "../../styles/global-styles";
import AddIcon from "@material-ui/icons/Add";
import { Button } from "@material-ui/core";
import NumberFormat from "react-number-format";
import StyleTableRow from "../../styles/styleTableRow";
import { connect } from "react-redux";
import { actions } from "../../redux/actions/shoppingCart";
import { actions as actionsAlert } from "../../redux/actions/alert";
import { isBalanceTransferInCart } from "../../_utils/utils";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
    "&:hover": {
      // backgroundColor: "#ccebff !important",
      cursor: "pointer",
    },
  },
  backgroundIcon: styles.backgroundIcon,
  link: styles.editLink,
  colorChip: styles.chip,
});

const CashCardInSiteRow = ({
  addAlert,
  detailAlert,
  row,
  row: { cash_card, id },
  addItemToCart,
  shoppingCart: { cart },
}) => {
  const classes = useRowStyles();

  const productExistInShoppingCart = () => {
    return Object.keys(cart).some((idProduct) => idProduct === id);
  };

  const handleAddItemToCart = (row) => {
    if (isBalanceTransferInCart(cart)) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "info",
        message:
          "Ya tienes en el carrito un trapaso de saldo. Favor de eliminar para continuar",
      });
      return;
    } else {
      addItemToCart({ item: row, quantity: 1 });
    }
  };

  return (
    <React.Fragment>
      <StyleTableRow hover key={id} className={classes.rowSelected}>
        <TableCell
          align="center"
          component="th"
          scope="row"
          style={{ fontWeight: 800, fontSize: 16 }}
        >
          {cash_card.id}
        </TableCell>
        <TableCell align="center">
          {cash_card.card_catalogue?.name || ""}
        </TableCell>
        <TableCell align="center">
          {cash_card.card_catalogue?.barCode}
        </TableCell>
        <TableCell align="center">
          <NumberFormat
            value={cash_card.card_catalogue?.amount || 0}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        </TableCell>
        <TableCell align="center">
          <Button
            variant="contained"
            color="primary"
            disabled={productExistInShoppingCart()}
            onClick={() => handleAddItemToCart(row)}
            endIcon={
              <AddIcon
                className={classes.backgroundIcon}
                color="primary"
              ></AddIcon>
            }
          >
            Agregar
          </Button>
        </TableCell>
      </StyleTableRow>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actionsAlert.detailAlert,
  addAlert: actionsAlert.addAlert,
  addItemToCart: actions.addItemToCart,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(CashCardInSiteRow);
